// components/BlurHashCanvas.jsx — Anamoria SPA
// v1.0 — Extracted verbatim from MemoryFeed.jsx v2.15 (Phase 3 step 3.1, F-3):
// MomentCard needs the same placeholder and importing it from MemoryFeed would
// create a circular import (MemoryFeed imports MomentCard). One implementation,
// zero behaviour change; MemoryFeed v2.16 imports from here.

import { useEffect, useRef } from 'react';
import { decode } from 'blurhash';
import styles from './BlurHashCanvas.module.css';

export default function BlurHashCanvas({ hash, width = 269, height = 180 }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    if (!canvasRef.current || !hash) return;
    try {
      const pixels = decode(hash, width, height);
      const ctx = canvasRef.current.getContext('2d');
      const imageData = ctx.createImageData(width, height);
      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);
    } catch (err) {
      console.warn('BlurHash decode failed:', err);
    }
  }, [hash, width, height]);
  return <canvas ref={canvasRef} width={width} height={height} className={styles.blurCanvas} />;
}
